import { render, staticRenderFns } from "./tabAndAd.vue?vue&type=template&id=7796ce1a&scoped=true"
import script from "./tabAndAd.vue?vue&type=script&lang=js"
export * from "./tabAndAd.vue?vue&type=script&lang=js"
import style0 from "./tabAndAd.vue?vue&type=style&index=0&id=7796ce1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796ce1a",
  null
  
)

export default component.exports